export default __webpack_public_path__ + "bf731c4b28ab839e61098619152d1822.png";